import { useEffect, useState } from 'react';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { v4 as uuid } from 'uuid';

import CarouselData from './CarouselData';
import CarouselView from './CarouselView';

const CarouselEdit = (props) => {
  const { onChangeBlock, block, selected } = props;
  const [focusedIndex, setFocusedIndex] = useState(null);

  useEffect(() => {
    if (!props.data.columns) {
      const data = {
        columns: [{ '@id': uuid() }, { '@id': uuid() }],
        items_to_show: 1,
        ...props.data,
      };
      onChangeBlock(block, data);
    }
  }, [props.data, block, onChangeBlock]);

  return (
    <>
      <div className="carousel-block__edit-container">
        <CarouselView {...props} isEditMode focusedIndex={focusedIndex} />
      </div>

      <SidebarPortal selected={selected}>
        <CarouselData
          {...props}
          data={props.data}
          block={block}
          onChangeBlock={onChangeBlock}
          onRequestFocusIndex={setFocusedIndex}
        />
      </SidebarPortal>
    </>
  );
};

export default CarouselEdit;
